/**
 * Enterprise UI slice — spacing, type scale, workspace chrome (TaskUIUX).
 * Complements NobleTokens; use for shell/object workspace consistency.
 */
export const EnterpriseTokens = {
  spacing: {
    xs: 4,
    sm: 8,
    md: 12,
    lg: 16,
    xl: 24,
    xxl: 32,
  },
  workspace: {
    headerPaddingY: 16,
    headerPaddingX: 20,
    /** Main column padding; use clamp() in components for responsive edge padding */
    bodyPadding: 24,
    bodyPaddingMin: 12,
    /** Right rail; full width below breakpoint via WorkspaceLayout.module.css */
    railWidth: 280,
    railStackBreakpointPx: 1024,
    borderSubtle: '1px solid #e8e8e8',
    surfaceMuted: '#fafafa',
    surfaceHeader: '#f8fafc',
  },
  typography: {
    objectTitle: { fontSize: 18, fontWeight: 600 as const, lineHeight: 1.3 },
    objectSubtitle: { fontSize: 13, color: '#595959' },
    sectionTitle: { fontSize: 15, fontWeight: 600 as const },
  },
} as const;
